import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { OpenBalanceTexts } from "../utils/openBalance-enums";
// Use a small component to avoid redefining the CancelButton in the main component
export const CancelButton = ({ isMobile, cancelButtonOnClick, }) => (_jsx(Button, Object.assign({ fullWidth: isMobile, color: "primary", variant: "outlined", size: "medium", sx: { whiteSpace: "nowrap" }, onClick: cancelButtonOnClick }, { children: OpenBalanceTexts.CANCEL })));
